import { render, staticRenderFns } from "./uploadImgUniversal.vue?vue&type=template&id=69032106&scoped=true"
import script from "./uploadImgUniversal.vue?vue&type=script&lang=js"
export * from "./uploadImgUniversal.vue?vue&type=script&lang=js"
import style0 from "./uploadImgUniversal.vue?vue&type=style&index=0&id=69032106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69032106",
  null
  
)

export default component.exports